import { BankDetailEditForm } from "Company/Modules/BankDetail/Components/Form/BankDetailEditForm";
import type { CompanyBankDetailWithRelationsResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";

type Props = {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	companyId: number;
	bankDetail: CompanyBankDetailWithRelationsResponseDto;
};

const bankDetailResources = Resources.base.bankDetail.shared;

export const BankDetailEditModal: FC<Props> = ({
	isOpen,
	setIsOpen,
	companyId,
	bankDetail,
}) => {
	const { t } = useResource();
	const handleCancel = () => {
		setIsOpen(false);
	};

	return (
		<Dialog open={isOpen} onClose={handleCancel}>
			<DialogTitle>{t(bankDetailResources.editBankDetail)}</DialogTitle>
			<DialogContent sx={{ pb: 1 }}>
				<BankDetailEditForm
					companyId={companyId}
					closeModal={handleCancel}
					bankDetail={bankDetail}
				/>
			</DialogContent>
		</Dialog>
	);
};
